// extracted by mini-css-extract-plugin
module.exports = {"reverted":"_3u8_jT","newPrice":"_2HHtNv","oldPrice":"_13ov15","diagonalLine":"URhIJq","horizontalLine":"eS8M3U","lineUnder":"_1uZKDu","shine-lines":"_39mxKS"};